import React from "react";

import { Grid } from "@mui/material";

import {
  AssignmentOutlined as AssignmentIcon,
  EventAvailableOutlined as EventAvailableIcon,
  ExploreOutlined as ExploreIcon,
  PermContactCalendarOutlined as PermContactCalendarOutlinedIcon,
} from "@mui/icons-material";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import moment from "moment";

import { StatCard } from "components";

class BriefInfoPanel extends React.Component {
  render() {
    const { lang, players, events, news, instructions } = this.props;

    moment.locale(lang.currentLanguage);

    let eventTitle = "Events";
    events &&
      events.check_start_date &&
      (eventTitle = `${eventTitle} (Since ${moment(
        events.check_start_date * 1000
      ).format("L")})`);

    let newsTitle = "News";
    news &&
      news.check_start_date &&
      (newsTitle = `${newsTitle} (Since ${moment(
        news.check_start_date * 1000
      ).format("L")})`);

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            type="fill"
            title="Players"
            value={players && players.total_count ? players.total_count : 0}
            icon={<PermContactCalendarOutlinedIcon />}
            color="#3f51b5"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            type="fill"
            title={eventTitle}
            value={events && events.total_count ? events.total_count : 0}
            icon={<EventAvailableIcon />}
            color="#9c27b0"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            type="fill"
            title={newsTitle}
            value={news && news.total_count ? news.total_count : 0}
            icon={<AssignmentIcon />}
            color="#f44336"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            type="fill"
            title="Instructions"
            value={
              instructions && instructions.total_count
                ? instructions.total_count
                : 0
            }
            icon={<ExploreIcon />}
            color="#ffd740"
          />
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.statistics.players,
    events: state.statistics.events,
    news: state.statistics.news,
    instructions: state.statistics.instructions,
    lang: state.lang,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, matchDispatchToProps)(BriefInfoPanel);
